import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueTheMask from 'vue-the-mask'
import vuetify from './plugins/vuetify'
import VueApexCharts from 'vue-apexcharts'
Vue.component('apexchart', VueApexCharts)

Vue.config.productionTip = false
Vue.use(VueTheMask)

/* ======================================================
   AUTO-REFRESH POR NUEVA VERSIÓN (SIN ERRORES NI LOOPS)
====================================================== */

// obtiene versión guardada
const storedVersion = localStorage.getItem('app_version')

// obtiene usuario guardado de forma segura
let usuarioGuardado = null
const usuarioLS = localStorage.getItem('usuario')

if (usuarioLS) {
  try {
    usuarioGuardado = JSON.parse(usuarioLS)
  } catch (e) {
    usuarioGuardado = null
  }
}
console.log(storedVersion)
console.log(__APP_VERSION__)
// console.log(Vue.config.productionTip)
// si la versión cambió → limpia cache
if (storedVersion && storedVersion !== __APP_VERSION__) {
  console.log('🔄 Nueva versión detectada, limpiando cache...')

  localStorage.clear()

  // restaura usuario
  if (usuarioGuardado) {
    localStorage.setItem('usuario', JSON.stringify(usuarioGuardado))
  }

  // guarda versión actual ANTES del reload (evita loop)
  localStorage.setItem('app_version', __APP_VERSION__)

  // limpia caches del navegador (PWA / Azure)
  if ('caches' in window) {
    caches.keys().then(keys => {
      keys.forEach(key => caches.delete(key))
    })
  }

  location.reload()
}

// guarda versión si no existe
if (!storedVersion) {
  localStorage.setItem('app_version', __APP_VERSION__)
}

/* ======================================================
   AXIOS
====================================================== */

axios.defaults.baseURL =
//axios.defaults.baseURL='http://localhost:44300/'
  // 'https://localhost:44300/'
//axios.defaults.baseURL='http://www.bateasapps.api.com/'
//axios.defaults.baseURL='https://empleomatchtest12.azurewebsites.net/'
//axios.defaults.baseURL='https://empleomatchtestbateas1.azurewebsites.net/'
//axios.defaults.baseURL='https://empresas-azure.azurewebsites.net/'
// axios.defaults.baseURL='https://bateas-gsfqbecvcrh9amap.centralus-01.azurewebsites.net/'
  'https://cesem-cvccdphwf9d8cpa6.centralus-01.azurewebsites.net/'

// si tienes token
if (usuarioGuardado?.token) {
  axios.defaults.headers.common['Authorization'] =
    `Bearer ${usuarioGuardado.token}`
}

/* ======================================================
   RESTAURA SESIÓN EN VUEX
====================================================== */

if (usuarioGuardado) {
  store.commit('setUsuario', usuarioGuardado)
}

/* ======================================================
   INICIALIZA VUE
====================================================== */

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
